import { render, staticRenderFns } from "./InsCmsCat8.vue?vue&type=template&id=6614a86d&scoped=true&"
import script from "./InsCmsCat8.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat8.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat8.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsCmsCat8.vue?vue&type=style&index=1&id=6614a86d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614a86d",
  null
  
)

export default component.exports